const FeeReappliedIcon = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx="14" fill="#FFF5E8" />
      <path
        d="M11.6797 11.1211H16.3214"
        stroke="#F98600"
        strokeWidth="0.933333"
        strokeMiterlimit="10"
      />
      <path
        d="M11.6797 12.6484H16.3214"
        stroke="#F98600"
        strokeWidth="0.933333"
        strokeMiterlimit="10"
      />
      <path
        d="M13.2151 11.1211C14.0578 11.1211 14.7442 11.8075 14.7442 12.6502C14.7442 13.4929 14.0578 14.1793 13.2151 14.1793C13.1452 14.1793 13.0767 14.1747 13.0097 14.1657C12.9235 14.1541 12.8388 14.2923 12.9002 14.3538L14.8801 16.3337"
        stroke="#F98600"
        strokeWidth="0.933333"
        strokeMiterlimit="10"
      />
      <path
        d="M19.543 19.0898L17.2914 19.0931L14.8224 19.0839C13.3448 19.0349 12.4363 18.9339 11.3352 18.2703C10.8166 17.9576 10.3427 17.5618 9.95187 17.1018C8.68959 15.6069 8.2966 13.6821 8.74179 11.9289C8.90077 11.2954 9.19414 10.7001 9.57715 10.175C10.2602 9.23377 11.2791 8.55946 12.1712 8.17557"
        stroke="#F98600"
        strokeWidth="0.933333"
        strokeMiterlimit="10"
      />
      <path
        d="M12.1703 8.1743C12.1703 8.1743 13.9995 7.39399 16.561 8.2881C16.5635 8.28896 16.5638 8.28898 16.5662 8.28999C16.6435 8.32198 19.912 9.6972 19.8984 13.3633"
        stroke="#F98600"
        strokeWidth="0.933333"
        strokeMiterlimit="10"
      />
      <path
        d="M18.1719 20.3902C18.1721 20.5263 18.3347 20.5965 18.4339 20.5034L19.8284 19.195C19.8958 19.1318 19.8935 19.024 19.8235 18.9637L18.4253 17.7595"
        fill="#F98600"
        stroke="#F98600"
        strokeWidth="0.933333"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default FeeReappliedIcon;
